import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { MailIcon, LinkedinIcon, SendIcon } from 'lucide-react';
export function Contact() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="contact" className="relative py-32 px-6 bg-gradient-to-br from-indigo-950 via-purple-900 to-pink-900 text-white overflow-hidden" data-id="element-24">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-25">
        <motion.div className="absolute top-20 left-20 w-96 h-96 bg-gradient-to-br from-pink-500/20 to-orange-500/20 rounded-full blur-3xl" animate={{
        scale: [1, 1.2, 1],
        x: [0, 30, 0],
        y: [0, 50, 0]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-26" />
        <motion.div className="absolute bottom-20 right-20 w-96 h-96 bg-gradient-to-br from-purple-500/20 to-blue-500/20 rounded-full blur-3xl" animate={{
        scale: [1, 1.3, 1],
        x: [0, -50, 0],
        y: [0, -30, 0]
      }} transition={{
        duration: 12,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-27" />
      </div>

      <div className="max-w-4xl mx-auto relative z-10" ref={ref} data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-29">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          delay: 0.2,
          duration: 0.6
        }} data-id="element-30">
            <h2 className="text-5xl md:text-6xl font-black mb-6" data-id="element-31">
              Let's Create Something
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-amber-400 via-pink-400 to-purple-400" data-id="element-32">
                Amazing Together
              </span>
            </h2>
            <div className="h-2 w-32 bg-gradient-to-r from-pink-500 to-orange-500 rounded-full mx-auto mb-8" data-id="element-33" />
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: 0.4,
          duration: 0.6
        }} className="text-xl text-purple-200 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-34">
            I'm always interested in hearing about new opportunities,
            collaborations, and exciting projects. Let's connect and build
            something great!
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: 0.6,
          duration: 0.6
        }} className="mb-16" data-id="element-35">
            <a href="mailto:your.email@example.com" className="group inline-flex items-center gap-3 px-10 py-5 bg-gradient-to-r from-pink-500 to-orange-500 text-white rounded-full text-lg font-bold hover:shadow-2xl hover:shadow-pink-500/50 transition-all duration-300 hover:scale-105" data-id="element-36">
              <SendIcon size={24} className="group-hover:rotate-45 transition-transform duration-300" data-id="element-37" />
              <span data-id="element-38">your.email@example.com</span>
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: 0.8,
          duration: 0.6
        }} data-id="element-39">
            <p className="text-purple-300 mb-6 font-medium" data-id="element-40">Or find me on</p>
            <div className="flex gap-6 justify-center" data-id="element-41">
              <a href="https://www.linkedin.com/in/chamanvir-kaur/" target="_blank" rel="noopener noreferrer" className="group p-4 bg-white/10 backdrop-blur-sm border-2 border-white/20 rounded-2xl hover:bg-white/20 hover:border-white/40 transition-all duration-300 hover:scale-110" aria-label="LinkedIn" data-id="element-42">
                <LinkedinIcon size={28} className="group-hover:text-amber-400 transition-colors" data-id="element-43" />
              </a>
              <a href="mailto:your.email@example.com" className="group p-4 bg-white/10 backdrop-blur-sm border-2 border-white/20 rounded-2xl hover:bg-white/20 hover:border-white/40 transition-all duration-300 hover:scale-110" aria-label="Email" data-id="element-44">
                <MailIcon size={28} className="group-hover:text-amber-400 transition-colors" data-id="element-45" />
              </a>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={isInView ? {
          opacity: 1
        } : {}} transition={{
          delay: 1,
          duration: 0.6
        }} className="mt-20 pt-8 border-t border-white/20" data-id="element-46">
            <p className="text-purple-300 text-sm" data-id="element-47">
              © 2024 Chamanvir Kaur. Designed & built with passion.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}